import { AbstractControl } from '@angular/forms';

export function ValidateString(control: AbstractControl) {
  var re1 = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
  var re2 = /^(\w+\s)*\w+$/
  if (!re1.test(control.value) || !re2.test(control.value)) {
        return { validString: true };
  } 
  return null;
}


export function ValidateCardName(control: AbstractControl) {
  var re1 = /[a-zA-Z][a-zA-Z ]+/;
  if (!re1.test(control.value) ) {
        return { validCard: true };
  } 
  return null;
}

export function ValidateFullySpecial(control: AbstractControl) {
  var re1 = /^(?=.[a-zA-ZáéíñóúüÁÉÍÑÓÚÜäöüÄÖÜß0])+/;
  if (!re1.test(control.value) ) {
        return { validSpecial: true };
  } 
  return null;
}




export function ValidateSpace(control: AbstractControl) {
  var re2 = /^([a-zA-ZáéíñóúüÁÉÍÑÓÚÜäöüÄÖÜß0-9]+\s)*[a-zA-ZáéíñóúüÁÉÍÑÓÚÜäöüÄÖÜß0-9]+$/
  if (!re2.test(control.value)) {
        return { validSpace: true };
  } 
  return null;
}


export function ValidateSpaces(control: AbstractControl) {
  var re2 = /^([a-zA-Z0-9_@./#&áéíñóúüÁÉÍÑÓÚÜäöüÄÖÜß0`'"$+-]+\s)*[a-zA-Z0-9_@./#&áéíñóúüÁÉÍÑÓÚÜäöüÄÖÜß0`'"$+-]+$/
  if (!re2.test(control.value)) {
        return { validSpaces: true };
  } 
  return null;
}



export function ValidateZipCode(control:AbstractControl){
    const zip = /^\d{5}$|^\d{5}-\d{4}$/
    if (!zip.test(control.value)) {
      return { validZip: true };
      
    }
    return null
}


export function ValidateRFC(control:AbstractControl){
  const rfc = /^[A-Za-z]{3,4}[ |\-]{0,1}[0-9]{6}[ |\-]{0,1}[0-9A-Za-z]{3}$/
  if (!rfc.test(control.value)) {
    return { validRfc: true };
    
  }
  return null
}


export function ValidateEmail(control:AbstractControl){
  const email = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!email.test(control.value)) {
    return { validEmail: true };
    
  }
  return null
}


export function ValidateCvv(control:AbstractControl){
  const regx = /^[0-9]{3,4}$/;
  if (!regx.test(control.value)) {
    return { validCvv: true };
  }
  return null
}


export function ValidateCard(control:AbstractControl){
  let value = (control.value)?control.value.replace(/ /g,''):''
  if (value.length > 16 || value.length < 15) {
    return { validCard: true };
  }
  return null
}

// /^(?=.*[a-zA-Z]).*$/   /(?!^\d+$)^.+$/    /(?![@#$%^&+=]+$)^.+$/


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_helpers/custom-validators.ts